import 'slick-carousel'
import $ from 'jquery'

class Slick {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._options = {
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: false,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null,
            prevBtn: null,
            nextBtn: null,
            ...JSON.parse(this._elem.getAttribute('data-slick') || '{}')
        }
        if (this._options.mobileOnly) this._options.showBelow = 769
    }

    onInit () {
        if (!this._options.dontInit) {
            if (this._options.showAbove && window.innerWidth <= this._options.showAbove) return false
            if (this._options.showBelow && window.innerWidth >= this._options.showBelow) return false
            this._slick()
        }

        const { _elem, _options } = this
        const { infinite, prevBtn, nextBtn, slidesToShow } = _options

        if (prevBtn) {
            this._btnInit(_elem, prevBtn, nextBtn, 'slickPrev', '0', '1', infinite)
        }

        if (nextBtn) {
            let lastSlide = _elem // this slider
                .firstChild.firstChild // -> .slick-list -> .slick-track
                .querySelectorAll('.slick-slide') // all slides
                .length - slidesToShow // minus slides to show

            if (window.innerWidth < 750) {
                lastSlide = lastSlide + 1
            }

            const hideIndicator = (lastSlide - 1).toString()

            this._btnInit(_elem, nextBtn, prevBtn, 'slickNext', lastSlide, hideIndicator, infinite)
        }
    }

    _btnInit (elem, thisBtn, otherBtn, action, slide, hideIndicator, infinite) {
        const active = elem.querySelector('.slick-active').getAttribute('data-slick-index')

        if (!infinite && active === slide) {
            $(thisBtn).css('display', 'none')
        } else {
            $(thisBtn).css('display', 'flex')
        }

        $(thisBtn).click(function () {
            const newActive = elem.querySelector('.slick-active').getAttribute('data-slick-index')
            $(otherBtn).css('display', 'flex')
            $(elem).slick(action)

            if (!infinite && newActive === hideIndicator) {
                $(thisBtn).css('display', 'none')
            }
        })
    }

    _slick () {
        $(this._elem).not('.slick-initialized').slick(this._options)
        this._elem.querySelector('video') && this._handleVideo()
    }

    _unslick () {
        $(this._elem).slick('unslick')
    }

    _handleVideo () {
        $(this._elem).on('init', (e, slick) => {
            const vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        $(this._elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            const vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.pause()
                slick.$slides[curSlide].querySelector('.video-container').classList.add('video-container--paused')
            }
        })

        $(this._elem).on('afterChange', (e, slick, curSlide) => {
            const vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
                slick.$slides[curSlide].querySelector('.video-container').classList.remove('video-container--paused')
            }
        })
    }
}

export default Slick



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slick.js